module.exports = __webpack_public_path__ + "07_hair_brown.ff3840d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/07_hair_brown.png
// module id = gCJH
// module chunks = 0